import { render, staticRenderFns } from "./post.vue?vue&type=template&id=ce3b101c&scoped=true&"
import script from "./post.vue?vue&type=script&lang=ts&"
export * from "./post.vue?vue&type=script&lang=ts&"
import style0 from "./post.vue?vue&type=style&index=0&id=ce3b101c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3b101c",
  null
  
)

export default component.exports